// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Christmas takes the header's spruce green, and keeps the gold halo on a
   confirmed square -- warm light on a green tree is the whole point. See
   assets/css/BingoCard.css for what each name means. */
:root {
  --wsb-accent: #0f6b34;
  --wsb-accent-ink: #ffffff;

  --wsb-bar-bg: linear-gradient(45deg, #1a7d43, #075226);
  --wsb-bar-ink-muted: #d8f0e0;
  --wsb-bar-glint: #ffd7d2;
  --wsb-badge-ink: #075226;

  --wsb-ink-muted: #4e5b50;
  --wsb-line: rgba(7, 82, 38, 0.28);
  --wsb-line-strong: rgba(7, 82, 38, 0.55);

  --wsb-accent-text: #0b5c2c;
  --wsb-chip-line: rgba(11, 92, 44, 0.45);

  --wsb-surface-hover: linear-gradient(to bottom, #d9efdf, #c3e3cc);
  --wsb-onbrand-line: rgba(242, 238, 221, 0.35);
  --wsb-snap-ring: rgba(255, 193, 94, 0.85);

  --wsb-toast-bg: rgba(15, 107, 52, 0.86);
  --wsb-toast-bg-idle: rgba(192, 57, 43, 0.82);
}

/* Reset and base styles */
* {
  font-family: 'Helvetica', sans-serif;
  padding: 0;
  margin: 0;
}

body {
  background-color: #c0392b;
  z-index: -4;
}

#my-canvas {
  position: absolute; /* Position the canvas absolutely within the parent */
  top: 0;
  left: 0;
  z-index: 0; /* Set a lower z-index value to place it behind other elements */
}

/* Snowflake keyframes with random fall durations and delays */
@keyframes snowflake-fall-1 {
  0% { transform: translateX(0) translateY(-100%); opacity: 0; }
  100% { transform: translateX(-100vw) translateY(100vh); opacity: 1; }
}

@keyframes snowflake-fall-2 {
  0% { transform: translateX(0) translateY(-100%); opacity: 0; }
  100% { transform: translateX(50vw) translateY(100vh); opacity: 1; }
}

@keyframes snowflake-fall-3 {
  0% { transform: translateX(0) translateY(-100%); opacity: 0; }
  100% { transform: translateX(25vw) translateY(100vh); opacity: 1; }
}

@keyframes snowflake-fall-4 {
  0% { transform: translateX(0) translateY(-100%); opacity: 0; }
  100% { transform: translateX(75vw) translateY(100vh); opacity: 1; }
}

@keyframes snowflake-fall-5 {
  0% { transform: translateX(0) translateY(-100%); opacity: 0; }
  100% { transform: translateX(65vw) translateY(100vh); opacity: 1; }
}

@keyframes snowflake-fall-6 {
  0% { transform: translateX(0) translateY(-100%); opacity: 0; }
  100% { transform: translateX(35vw) translateY(100vh); opacity: 1; }
}

/* Snowflake container */
.snowflake-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  pointer-events: none;
  overflow: hidden;
  z-index: 9999;
}

/* Individual snowflake styles */
.snowflake-container::before,
.snowflake-container::after {
  content: '';
  position: absolute;
  top: -10%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 0 10px white;
  animation: snowflake-fall-1 5s linear infinite;
}

.snowflake-container:nth-child(2)::before,
.snowflake-container:nth-child(2)::after {
  animation: snowflake-fall-2 8s linear infinite;
}

/* Randomize the size and position of snowflakes */
.snowflake-container::before {
  width: 3px; /* Smaller snowflake */
  height: 3px;
  left: 20%; /* Different starting position */
}

.snowflake-container::after {
  width: 6px; /* Larger snowflake */
  height: 6px;
  left: 80%; /* Different starting position */
}

@keyframes snowflake {
  0% {
    transform: translateY(0) translateX(0) scale(1);
  }
  100% {
    transform: translateY(120vh) translateX(-120vw) scale(0.2); /* Larger movement and scale change */
  }
}

.user-count {
  margin-top: 5px;
  animation: typing 0.5s steps(20, end);
}

nav {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background-color: #c0392b;
  position: relative;
  z-index: 1; /* Set a lower z-index value to place it behind other elements */
}

p {
  color: #FFF;
}

/*
.bingo-card {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  max-width: 500px;
  margin: 20px auto;
  padding: 15px;
  border-radius: 20px;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.3);
}
*/

/* Style for the hamburger menu */
/*.hamburger-menu {
  display: none; /* Hide the menu by default */
  /*position: relative;
  cursor: pointer;
}

/* Style for the open state of the hamburger icon */
/*.hamburger-menu.open .bar:nth-child(1) {
  transform: rotate(-45deg) translate(-5px, 6px);
}

.hamburger-menu.open .bar:nth-child(2) {
  opacity: 0;
}

.hamburger-menu.open .bar:nth-child(3) {
  transform: rotate(45deg) translate(-5px, -6px);
}

/* Style for the menu items */
.menu {
  display: none;
  position: absolute;
  top: 48px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}

.menu a {
  display: block;
  padding: 12px 16px;
  text-decoration: none;
  color: #333;
  transition: background-color 0.3s;
}

.menu a:hover {
  background-color: #ddd;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  padding: 0 20px;
}

.nav-logo img {
  height: 40px;
}

.nav-links a {
  color: white;
  text-decoration: none;
  margin: 0 10px;
  font-size: 18px;
}

.nav-login a {
  color: white;
  text-decoration: none;
  font-size: 18px;
}

/* Apply styles to the theme selector dropdown */
#themeSelector {
  background-color: #d2480c;
  border: 1px solid #9a3206;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  color: #ffffff;
}

/* Apply styles to the label of the theme selector dropdown */
.theme-selector-label {
  font-weight: bold;
  color: #ffffff;
}


@keyframes typing {
  from {
    width: 0;
  }
}

#bodyWrapper {
  width: 1000px;
  display: block;
  margin: 0px auto;
  padding-top: 50px;
  padding-bottom: 50px;
}

#game {
  /* width: 100%; */
  display: inline-block;
  background: linear-gradient(to bottom, #27ae60, #1a7d43, #075226);
  padding: 15px 10px;
  padding-left: 2.5px;
  text-align: center;
  color: white;
  font-size: 14pt;
  border-radius: 20px;
  box-shadow: 10px 10px 12px -15px black;
  padding: 25px; /* Increase padding to accommodate lights */
  background-image: url('https://cdn.wanshow.bingo/resources/images/christmas-lights.png'), linear-gradient(to bottom, #27ae60, #1a7d43, #075226);
  background-repeat: repeat-x; /* Repeat lights horizontally */
  background-position: top center, center center; /* Position lights at the top */
}

#game p {
  line-height: 30px;
  text-shadow: 1px 1px 1px #00000056;
}

#game a {
  color: white;
}

.hidden {
  display: none;
}

.board {
  width: 1000px;
  margin: auto;
  /* display: block; COMMENT OUT Woffer FIX */
  display: grid; /* Woffer FIX */
  grid-template-columns: auto auto auto auto auto; /* Woffer FIX */
}

#whenplane {
  padding-bottom: 10px;
}

#board {
  /* display: inline-grid; COMMENT OUT Woffer FIX */ /* added to make the area a grid */
  position: relative; /* Added to position the background image */
  /* grid-template-columns: auto auto auto auto auto; COMMET OUT Woffer FIX */ /* gives the grid 5 columns no matter what size screen you are on */
  z-index: 1;  /*Added to stack the game board above the background image */
  transform-origin: top left; /* Scale from the top left corner */
  align-items: center;
  /*display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-wrap: wrap; Allow items to wrap onto the next line */
}

#board::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("https://cdn.wanshow.bingo/resources/images/christmaslinus.png");
  background-size: cover;
  background-position: center;
  background-attachment: fixed; /* Changed to fixed to keep the background image in place */
  z-index: -1; /* Stack the background image below the grid items */
}

.item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% / 5 - 10px); /* adjust the denominator based on how many items you want in a row */
  vertical-align: middle;
  text-align: center;
  width: 178px;
  height: 153px;
  border: 1px #ffffff solid;
  background-image: url("https://cdn.wanshow.bingo/resources/images/paper-christmaswanshow2023.png");
  float: left;
  color: rgba(255, 255, 255, 0.933);
  padding: 10px;
  background-color: rgb(0 0 0 / 55%);
  background-blend-mode: darken;
  text-shadow: 2px 2px 4px rgba(169, 5, 5, 0.287);
}

.item p {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.title {
  width: 100%;
  text-align: center;
  margin-top: 15px;
  font-size: 32pt;
}

.clicked {
  background: linear-gradient(to right, #b5226200, #893f8e00);
  color: #27ae60;
  text-shadow: 2px 2px 4px rgba(181, 4, 4, 0.287);
  border-color: #000000;
  animation: borderColorChange 2s infinite;
  background-color: #0000004f; /* Thank you Woffer */
  background-blend-mode: darken;
}

/* Christmas colors animation */
@keyframes borderColorChange {
  0%, 100% {
    border-color: #c0392b; /* Christmas Red */
  }
  33% {
    border-color: #27ae60; /* Christmas Green */
  }
  66% {
    border-color: #ffffff; /* White */
  }
}

.footer {
  padding: 1rem 0;
  width: 100%;
  /* position: absolute; */
  bottom: 0;
}

.footer-container {
  display: flex;
  justify-content: space-around;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;
}

.footer-links {
  display: flex;
  align-items: center;
}

.footer-links a {
  color: #27ae60;
  text-decoration: none;
  margin-right: 1rem;
}

.footer-links a:hover {
  color: #27ae60;
}

/* Remove underline from footer & a href */
.footer-links a:hover {
  text-decoration: none;
}

.footer-copyright {
  color: #f2f2f2;
  font-size: 0.9rem;
}

a {
  color: white;
}

a:hover {
  color: #27ae60;
}

#team {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.section {
  flex: 0 0 48%; /* Each section will take up 48% of the available space */
  margin: 10px;
  /* Add media query to stack sections vertically on smaller screens */
}

.discord-banner {
  display: flex;
  align-items: center;
  background-color: #5865F2; /* Discord's blurple color from the color palette */
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  margin-top: 10px;
  width: -moz-fit-content;
  width: fit-content;
}

.discord-icon {
  font-size: 18px;
  margin-right: 5px;
}

.discord-tag {
  font-size: 14px;
}

.member {
  /* width: calc(50% - 20px); */
  margin: 10px;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
}

.member img {
  width: 150px;
  border-radius: 50%;
}

.member h2 {
  font-size: 24px;
  margin-top: 10px;
}

.member p {
  margin-top: 5px;
}

.member .social-links {
  margin-top: 10px;
}

.member .social-links a {
  color: #555;
  text-decoration: none;
  margin-right: 10px;
  font-size: 18px;
}

.member .social-links a:hover {
  color: #ff6600;
}

.countdown-box.svelte-1xheok0 {
  min-width: 23em;
  margin: 0 auto;
  font-family: "Dosis", sans-serif;
  background-color: #c0392b;
  padding: 15px 10px;
  text-align: center;
  color: rgb(255, 255, 255);
  font-size: 14pt;
  border-radius: 20px;
  box-shadow: 10px 10px 12px -15px black;
}

.countdown-box.svelte-1xheok0 {
  width: auto; /* Adjust to content */
  max-width: 550px;
  margin: 20px auto; /* Center the box */
  font-family: 'Dosis', sans-serif;
  background-color: #c0392b; /* Merry Chrysler */
  padding: 15px 20px; /* Increased padding */
  text-align: center;
  color: rgb(255, 255, 255);
  font-size: 14pt;
  border-radius: 20px;
  box-shadow: 10px 10px 12px -15px black;
  white-space: nowrap; /* Prevents the text from wrapping */
}

.provider-text {
  font-size: 10pt;
  text-align: right;
  color: #ffffff;
}

#wan-show-timer a {
  text-decoration: none;
  color: #ffffff;
  display: block; /* Make the entire area clickable */
}

.discord-banner {
  display: flex;
  align-items: center;
  background-color: #5865F2; /* Discord's blurple color from the color palette */
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  margin-top: 10px;
  width: -moz-fit-content;
  width: fit-content;
}

.discord-icon {
  font-size: 18px;
  margin-right: 5px;
}

.discord-tag {
  font-size: 14px;
}

.discord-tag {
  background-color: #5865F2; /* Discord's purple color from the color palette */
  padding: 5px 10px;
  border-radius: 15px;
  display: inline-block;
}

.discord-banner::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  border-radius: 20px;
  z-index: -1;
}

.member {
  margin-bottom: 20px;
}

.section h2 {
  color: white;
}

@media (max-width: 768px) {
  .section {
    flex: 0 0 100%; /* On smaller screens, each section takes up 100% of the available space */
  }
}

@media (max-width: 768px) {
  .member {
    width: calc(50% - 18px);
  }
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    text-align: center;
  }

  .footer-links {
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 3840px) {
  #game {
    transform: scale(1.0); /* Scale down to 90% on smaller screens */
    transform-origin: center;   
  }

  #nav-container {
    transform: scale(0.8); /* Scale down to 80% on even smaller screens */
    transform-origin: center;   
  }
}

@media (max-width: 1920px) {
  #game {
    transform: scale(0.98); /* Scale down to 90% on smaller screens */
    transform-origin: center;   
    padding-left: 10px;
  }

  #whenplane {
    transform: scale(0.98); 
  }
}

@media (max-width: 1200px) {
  #game {
    transform: scale(0.98);  
    transform-origin: center;   
    padding-left: 10px;
    margin-left: 18px;
  }

  #whenplane {
    transform: scale(0.98);
    margin-top: 0px;  
  }
}

@media (max-width: 1150px) {
  #game {
    transform: scale(0.96);  
    transform-origin: center;   
    padding-left: 10px;
    margin-left: 18px;
  }

  #whenplane {
    transform: scale(0.96);
    margin-top: -2px;  
  }
}

@media (max-width: 1100px) {
  #game {
    transform: scale(0.99);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }

  #whenplane {
    transform: scale(0.99);
    margin-top: 0px;  
  }
}

@media (max-width: 1070px) {
  #game {
    transform: scale(0.98);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1060px) {
  #game {
    transform: scale(0.97);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1050px) {
  #game {
    transform: scale(0.96);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1040px) {
  #game {
    transform: scale(0.95);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1030px) {
  #game {
    transform: scale(0.94);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1020px) {
  #game {
    transform: scale(0.93);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1010px) {
  #game {
    transform: scale(0.92);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }

  #whenplane {
    transform: scale(0.92);  
  }
}

@media (max-width: 1000px) {
  #game {
    transform: scale(0.91);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
    margin-top: -80px;
  }
}

@media (max-width: 950px) {
  #game {
    transform: scale(0.86);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
    margin-top: -100px;
  }
}

@media (max-width: 900px) {
  #game {
    transform: scale(0.81);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
    margin-top: -120px;
  }

  #whenplane {
    transform: scale(0.81);
    margin-top: -125px;  
  }
}

@media (max-width: 850px) {
  #game {
    transform: scale(0.76);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
    margin-top: -140px;
  }

  #whenplane {
    transform: scale(0.76);
    margin-top: -150px;  
  }
}

@media (max-width: 800px) {
  #game {
    transform: scale(0.71);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 3px;
    margin-top: -160px;
  }

  #whenplane {
    transform: scale(0.71);
    margin-top: -175px;  
  }
}

@media (max-width: 750px) {
  #game {
    transform: scale(0.66);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 2px;
    margin-top: -180px;
  }

  #whenplane {
    transform: scale(0.66);
    margin-top: -200px;  
  }
}

@media (max-width: 600px) {
  #game {
    transform: scale(0.56);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 1px;
    margin-top: -200px;
  }

  #whenplane {
    transform: scale(0.56);
    margin-top: -275px;  
  }
}

@media (max-width: 550px) {
  #game {
    transform: scale(0.52);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 0px;
    margin-top: -220px;
  }
}

@media (max-width: 500px) {
  #game {
    transform: scale(0.48);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 0px;
    margin-top: -240px;
  }

  #whenplane {
    transform: scale(0.48);  
    padding-top: -50px;
  }
}

@media (max-width: 480px) {
  #game {
    transform: scale(0.46); /* Scale down to 50% on the smallest screens */
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 0px;
    margin-top: -248px;
  }
}

@media (max-width: 450px) {
  #game {
    transform: scale(0.42);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 0px;
    margin-top: -260px;
  }
}

@media (max-width: 768px) {
  .nav-links {
    display: none;
  }

  .hamburger-menu {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/BingoCard-Christmas23.css"],"names":[],"mappings":"AAAA;;uDAEuD;AACvD;EACE,qBAAqB;EACrB,yBAAyB;;EAEzB,sDAAsD;EACtD,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;;EAExB,wBAAwB;EACxB,iCAAiC;EACjC,wCAAwC;;EAExC,0BAA0B;EAC1B,uCAAuC;;EAEvC,iEAAiE;EACjE,6CAA6C;EAC7C,yCAAyC;;EAEzC,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB,EAAE,qDAAqD;EACzE,MAAM;EACN,OAAO;EACP,UAAU,EAAE,gEAAgE;AAC9E;;AAEA,8DAA8D;AAC9D;EACE,KAAK,0CAA0C,EAAE,UAAU,EAAE;EAC7D,OAAO,+CAA+C,EAAE,UAAU,EAAE;AACtE;;AAEA;EACE,KAAK,0CAA0C,EAAE,UAAU,EAAE;EAC7D,OAAO,6CAA6C,EAAE,UAAU,EAAE;AACpE;;AAEA;EACE,KAAK,0CAA0C,EAAE,UAAU,EAAE;EAC7D,OAAO,6CAA6C,EAAE,UAAU,EAAE;AACpE;;AAEA;EACE,KAAK,0CAA0C,EAAE,UAAU,EAAE;EAC7D,OAAO,6CAA6C,EAAE,UAAU,EAAE;AACpE;;AAEA;EACE,KAAK,0CAA0C,EAAE,UAAU,EAAE;EAC7D,OAAO,6CAA6C,EAAE,UAAU,EAAE;AACpE;;AAEA;EACE,KAAK,0CAA0C,EAAE,UAAU,EAAE;EAC7D,OAAO,6CAA6C,EAAE,UAAU,EAAE;AACpE;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;;AAEA,gCAAgC;AAChC;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA,kDAAkD;AAClD;EACE,UAAU,EAAE,sBAAsB;EAClC,WAAW;EACX,SAAS,EAAE,gCAAgC;AAC7C;;AAEA;EACE,UAAU,EAAE,qBAAqB;EACjC,WAAW;EACX,SAAS,EAAE,gCAAgC;AAC7C;;AAEA;EACE;IACE,+CAA+C;EACjD;EACA;IACE,0DAA0D,EAAE,qCAAqC;EACnG;AACF;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU,EAAE,gEAAgE;AAC9E;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;;;;;;CAWC;;AAED,iCAAiC;AACjC;8CAC8C;EAC5C;;;;mDAIiD;AACnD;;;;;;;;;;;;6BAY6B;AAC7B;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,iEAAiE;EACjE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,aAAa,EAAE,2CAA2C;EAC1D,+IAA+I;EAC/I,2BAA2B,EAAE,+BAA+B;EAC5D,8CAA8C,EAAE,+BAA+B;AACjF;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,aAAa,EAAE,eAAe;EAC9B,+CAA+C,EAAE,eAAe;AAClE;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iDAAiD,EAAE,kCAAkC;EACrF,kBAAkB,EAAE,2CAA2C;EAC/D,2EAA2E,EAAE,mEAAmE;EAChJ,UAAU,GAAG,4DAA4D;EACzE,0BAA0B,EAAE,mCAAmC;EAC/D,mBAAmB;EACnB;;;2DAGyD;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B,EAAE,2DAA2D;EACzF,WAAW,EAAE,oDAAoD;AACnE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B,EAAE,qEAAqE;EACnG,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kGAAkG;EAClG,WAAW;EACX,iCAAiC;EACjC,aAAa;EACb,kCAAkC;EAClC,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2DAA2D;EAC3D,cAAc;EACd,+CAA+C;EAC/C,qBAAqB;EACrB,wCAAwC;EACxC,2BAA2B,EAAE,qBAAqB;EAClD,6BAA6B;AAC/B;;AAEA,+BAA+B;AAC/B;EACE;IACE,qBAAqB,EAAE,kBAAkB;EAC3C;EACA;IACE,qBAAqB,EAAE,oBAAoB;EAC7C;EACA;IACE,qBAAqB,EAAE,UAAU;EACnC;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa,EAAE,yDAAyD;EACxE,YAAY;EACZ,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB,EAAE,mDAAmD;EAC9E,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW,EAAE,sBAAsB;EACnC,gBAAgB;EAChB,iBAAiB,EAAE,mBAAmB;EACtC,gCAAgC;EAChC,yBAAyB,EAAE,mBAAmB;EAC9C,kBAAkB,EAAE,sBAAsB;EAC1C,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB,EAAE,oCAAoC;AAC3D;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc,EAAE,mCAAmC;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB,EAAE,mDAAmD;EAC9E,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,kDAAkD;EAC7E,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,cAAc,EAAE,0EAA0E;EAC5F;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB,EAAE,yCAAyC;IAChE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB,EAAE,8CAA8C;IACrE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,sBAAsB,EAAE,yCAAyC;IACjE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB,EAAE,8CAA8C;IACtE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Christmas takes the header's spruce green, and keeps the gold halo on a\n   confirmed square -- warm light on a green tree is the whole point. See\n   assets/css/BingoCard.css for what each name means. */\n:root {\n  --wsb-accent: #0f6b34;\n  --wsb-accent-ink: #ffffff;\n\n  --wsb-bar-bg: linear-gradient(45deg, #1a7d43, #075226);\n  --wsb-bar-ink-muted: #d8f0e0;\n  --wsb-bar-glint: #ffd7d2;\n  --wsb-badge-ink: #075226;\n\n  --wsb-ink-muted: #4e5b50;\n  --wsb-line: rgba(7, 82, 38, 0.28);\n  --wsb-line-strong: rgba(7, 82, 38, 0.55);\n\n  --wsb-accent-text: #0b5c2c;\n  --wsb-chip-line: rgba(11, 92, 44, 0.45);\n\n  --wsb-surface-hover: linear-gradient(to bottom, #d9efdf, #c3e3cc);\n  --wsb-onbrand-line: rgba(242, 238, 221, 0.35);\n  --wsb-snap-ring: rgba(255, 193, 94, 0.85);\n\n  --wsb-toast-bg: rgba(15, 107, 52, 0.86);\n  --wsb-toast-bg-idle: rgba(192, 57, 43, 0.82);\n}\n\n/* Reset and base styles */\n* {\n  font-family: 'Helvetica', sans-serif;\n  padding: 0;\n  margin: 0;\n}\n\nbody {\n  background-color: #c0392b;\n  z-index: -4;\n}\n\n#my-canvas {\n  position: absolute; /* Position the canvas absolutely within the parent */\n  top: 0;\n  left: 0;\n  z-index: 0; /* Set a lower z-index value to place it behind other elements */\n}\n\n/* Snowflake keyframes with random fall durations and delays */\n@keyframes snowflake-fall-1 {\n  0% { transform: translateX(0) translateY(-100%); opacity: 0; }\n  100% { transform: translateX(-100vw) translateY(100vh); opacity: 1; }\n}\n\n@keyframes snowflake-fall-2 {\n  0% { transform: translateX(0) translateY(-100%); opacity: 0; }\n  100% { transform: translateX(50vw) translateY(100vh); opacity: 1; }\n}\n\n@keyframes snowflake-fall-3 {\n  0% { transform: translateX(0) translateY(-100%); opacity: 0; }\n  100% { transform: translateX(25vw) translateY(100vh); opacity: 1; }\n}\n\n@keyframes snowflake-fall-4 {\n  0% { transform: translateX(0) translateY(-100%); opacity: 0; }\n  100% { transform: translateX(75vw) translateY(100vh); opacity: 1; }\n}\n\n@keyframes snowflake-fall-5 {\n  0% { transform: translateX(0) translateY(-100%); opacity: 0; }\n  100% { transform: translateX(65vw) translateY(100vh); opacity: 1; }\n}\n\n@keyframes snowflake-fall-6 {\n  0% { transform: translateX(0) translateY(-100%); opacity: 0; }\n  100% { transform: translateX(35vw) translateY(100vh); opacity: 1; }\n}\n\n/* Snowflake container */\n.snowflake-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  pointer-events: none;\n  overflow: hidden;\n  z-index: 9999;\n}\n\n/* Individual snowflake styles */\n.snowflake-container::before,\n.snowflake-container::after {\n  content: '';\n  position: absolute;\n  top: -10%;\n  left: 50%;\n  width: 5px;\n  height: 5px;\n  background: white;\n  border-radius: 50%;\n  box-shadow: 0 0 10px white;\n  animation: snowflake-fall-1 5s linear infinite;\n}\n\n.snowflake-container:nth-child(2)::before,\n.snowflake-container:nth-child(2)::after {\n  animation: snowflake-fall-2 8s linear infinite;\n}\n\n/* Randomize the size and position of snowflakes */\n.snowflake-container::before {\n  width: 3px; /* Smaller snowflake */\n  height: 3px;\n  left: 20%; /* Different starting position */\n}\n\n.snowflake-container::after {\n  width: 6px; /* Larger snowflake */\n  height: 6px;\n  left: 80%; /* Different starting position */\n}\n\n@keyframes snowflake {\n  0% {\n    transform: translateY(0) translateX(0) scale(1);\n  }\n  100% {\n    transform: translateY(120vh) translateX(-120vw) scale(0.2); /* Larger movement and scale change */\n  }\n}\n\n.user-count {\n  margin-top: 5px;\n  animation: typing 0.5s steps(20, end);\n}\n\nnav {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  background-color: #c0392b;\n  position: relative;\n  z-index: 1; /* Set a lower z-index value to place it behind other elements */\n}\n\np {\n  color: #FFF;\n}\n\n/*\n.bingo-card {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 10px;\n  max-width: 500px;\n  margin: 20px auto;\n  padding: 15px;\n  border-radius: 20px;\n  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.3);\n}\n*/\n\n/* Style for the hamburger menu */\n/*.hamburger-menu {\n  display: none; /* Hide the menu by default */\n  /*position: relative;\n  cursor: pointer;\n}\n\n/* Style for the open state of the hamburger icon */\n/*.hamburger-menu.open .bar:nth-child(1) {\n  transform: rotate(-45deg) translate(-5px, 6px);\n}\n\n.hamburger-menu.open .bar:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger-menu.open .bar:nth-child(3) {\n  transform: rotate(45deg) translate(-5px, -6px);\n}\n\n/* Style for the menu items */\n.menu {\n  display: none;\n  position: absolute;\n  top: 48px;\n  right: 0;\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n  z-index: 1;\n}\n\n.menu a {\n  display: block;\n  padding: 12px 16px;\n  text-decoration: none;\n  color: #333;\n  transition: background-color 0.3s;\n}\n\n.menu a:hover {\n  background-color: #ddd;\n}\n\n.nav-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n  padding: 0 20px;\n}\n\n.nav-logo img {\n  height: 40px;\n}\n\n.nav-links a {\n  color: white;\n  text-decoration: none;\n  margin: 0 10px;\n  font-size: 18px;\n}\n\n.nav-login a {\n  color: white;\n  text-decoration: none;\n  font-size: 18px;\n}\n\n/* Apply styles to the theme selector dropdown */\n#themeSelector {\n  background-color: #d2480c;\n  border: 1px solid #9a3206;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 14px;\n  color: #ffffff;\n}\n\n/* Apply styles to the label of the theme selector dropdown */\n.theme-selector-label {\n  font-weight: bold;\n  color: #ffffff;\n}\n\n\n@keyframes typing {\n  from {\n    width: 0;\n  }\n}\n\n#bodyWrapper {\n  width: 1000px;\n  display: block;\n  margin: 0px auto;\n  padding-top: 50px;\n  padding-bottom: 50px;\n}\n\n#game {\n  /* width: 100%; */\n  display: inline-block;\n  background: linear-gradient(to bottom, #27ae60, #1a7d43, #075226);\n  padding: 15px 10px;\n  padding-left: 2.5px;\n  text-align: center;\n  color: white;\n  font-size: 14pt;\n  border-radius: 20px;\n  box-shadow: 10px 10px 12px -15px black;\n  padding: 25px; /* Increase padding to accommodate lights */\n  background-image: url('https://cdn.wanshow.bingo/resources/images/christmas-lights.png'), linear-gradient(to bottom, #27ae60, #1a7d43, #075226);\n  background-repeat: repeat-x; /* Repeat lights horizontally */\n  background-position: top center, center center; /* Position lights at the top */\n}\n\n#game p {\n  line-height: 30px;\n  text-shadow: 1px 1px 1px #00000056;\n}\n\n#game a {\n  color: white;\n}\n\n.hidden {\n  display: none;\n}\n\n.board {\n  width: 1000px;\n  margin: auto;\n  /* display: block; COMMENT OUT Woffer FIX */\n  display: grid; /* Woffer FIX */\n  grid-template-columns: auto auto auto auto auto; /* Woffer FIX */\n}\n\n#whenplane {\n  padding-bottom: 10px;\n}\n\n#board {\n  /* display: inline-grid; COMMENT OUT Woffer FIX */ /* added to make the area a grid */\n  position: relative; /* Added to position the background image */\n  /* grid-template-columns: auto auto auto auto auto; COMMET OUT Woffer FIX */ /* gives the grid 5 columns no matter what size screen you are on */\n  z-index: 1;  /*Added to stack the game board above the background image */\n  transform-origin: top left; /* Scale from the top left corner */\n  align-items: center;\n  /*display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  flex-wrap: wrap; Allow items to wrap onto the next line */\n}\n\n#board::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: url(\"https://cdn.wanshow.bingo/resources/images/christmaslinus.png\");\n  background-size: cover;\n  background-position: center;\n  background-attachment: fixed; /* Changed to fixed to keep the background image in place */\n  z-index: -1; /* Stack the background image below the grid items */\n}\n\n.item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% / 5 - 10px); /* adjust the denominator based on how many items you want in a row */\n  vertical-align: middle;\n  text-align: center;\n  width: 178px;\n  height: 153px;\n  border: 1px #ffffff solid;\n  background-image: url(\"https://cdn.wanshow.bingo/resources/images/paper-christmaswanshow2023.png\");\n  float: left;\n  color: rgba(255, 255, 255, 0.933);\n  padding: 10px;\n  background-color: rgb(0 0 0 / 55%);\n  background-blend-mode: darken;\n  text-shadow: 2px 2px 4px rgba(169, 5, 5, 0.287);\n}\n\n.item p {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n}\n\n.title {\n  width: 100%;\n  text-align: center;\n  margin-top: 15px;\n  font-size: 32pt;\n}\n\n.clicked {\n  background: linear-gradient(to right, #b5226200, #893f8e00);\n  color: #27ae60;\n  text-shadow: 2px 2px 4px rgba(181, 4, 4, 0.287);\n  border-color: #000000;\n  animation: borderColorChange 2s infinite;\n  background-color: #0000004f; /* Thank you Woffer */\n  background-blend-mode: darken;\n}\n\n/* Christmas colors animation */\n@keyframes borderColorChange {\n  0%, 100% {\n    border-color: #c0392b; /* Christmas Red */\n  }\n  33% {\n    border-color: #27ae60; /* Christmas Green */\n  }\n  66% {\n    border-color: #ffffff; /* White */\n  }\n}\n\n.footer {\n  padding: 1rem 0;\n  width: 100%;\n  /* position: absolute; */\n  bottom: 0;\n}\n\n.footer-container {\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.footer-links {\n  display: flex;\n  align-items: center;\n}\n\n.footer-links a {\n  color: #27ae60;\n  text-decoration: none;\n  margin-right: 1rem;\n}\n\n.footer-links a:hover {\n  color: #27ae60;\n}\n\n/* Remove underline from footer & a href */\n.footer-links a:hover {\n  text-decoration: none;\n}\n\n.footer-copyright {\n  color: #f2f2f2;\n  font-size: 0.9rem;\n}\n\na {\n  color: white;\n}\n\na:hover {\n  color: #27ae60;\n}\n\n#team {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.section {\n  flex: 0 0 48%; /* Each section will take up 48% of the available space */\n  margin: 10px;\n  /* Add media query to stack sections vertically on smaller screens */\n}\n\n.discord-banner {\n  display: flex;\n  align-items: center;\n  background-color: #5865F2; /* Discord's blurple color from the color palette */\n  color: #fff;\n  padding: 5px;\n  border-radius: 5px;\n  margin-top: 10px;\n  width: fit-content;\n}\n\n.discord-icon {\n  font-size: 18px;\n  margin-right: 5px;\n}\n\n.discord-tag {\n  font-size: 14px;\n}\n\n.member {\n  /* width: calc(50% - 20px); */\n  margin: 10px;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  position: relative;\n}\n\n.member img {\n  width: 150px;\n  border-radius: 50%;\n}\n\n.member h2 {\n  font-size: 24px;\n  margin-top: 10px;\n}\n\n.member p {\n  margin-top: 5px;\n}\n\n.member .social-links {\n  margin-top: 10px;\n}\n\n.member .social-links a {\n  color: #555;\n  text-decoration: none;\n  margin-right: 10px;\n  font-size: 18px;\n}\n\n.member .social-links a:hover {\n  color: #ff6600;\n}\n\n.countdown-box.svelte-1xheok0 {\n  min-width: 23em;\n  margin: 0 auto;\n  font-family: \"Dosis\", sans-serif;\n  background-color: #c0392b;\n  padding: 15px 10px;\n  text-align: center;\n  color: rgb(255, 255, 255);\n  font-size: 14pt;\n  border-radius: 20px;\n  box-shadow: 10px 10px 12px -15px black;\n}\n\n.countdown-box.svelte-1xheok0 {\n  width: auto; /* Adjust to content */\n  max-width: 550px;\n  margin: 20px auto; /* Center the box */\n  font-family: 'Dosis', sans-serif;\n  background-color: #c0392b; /* Merry Chrysler */\n  padding: 15px 20px; /* Increased padding */\n  text-align: center;\n  color: rgb(255, 255, 255);\n  font-size: 14pt;\n  border-radius: 20px;\n  box-shadow: 10px 10px 12px -15px black;\n  white-space: nowrap; /* Prevents the text from wrapping */\n}\n\n.provider-text {\n  font-size: 10pt;\n  text-align: right;\n  color: #ffffff;\n}\n\n#wan-show-timer a {\n  text-decoration: none;\n  color: #ffffff;\n  display: block; /* Make the entire area clickable */\n}\n\n.discord-banner {\n  display: flex;\n  align-items: center;\n  background-color: #5865F2; /* Discord's blurple color from the color palette */\n  color: #fff;\n  padding: 5px;\n  border-radius: 5px;\n  margin-top: 10px;\n  width: fit-content;\n}\n\n.discord-icon {\n  font-size: 18px;\n  margin-right: 5px;\n}\n\n.discord-tag {\n  font-size: 14px;\n}\n\n.discord-tag {\n  background-color: #5865F2; /* Discord's purple color from the color palette */\n  padding: 5px 10px;\n  border-radius: 15px;\n  display: inline-block;\n}\n\n.discord-banner::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: calc(100% + 10px);\n  height: calc(100% + 10px);\n  border-radius: 20px;\n  z-index: -1;\n}\n\n.member {\n  margin-bottom: 20px;\n}\n\n.section h2 {\n  color: white;\n}\n\n@media (max-width: 768px) {\n  .section {\n    flex: 0 0 100%; /* On smaller screens, each section takes up 100% of the available space */\n  }\n}\n\n@media (max-width: 768px) {\n  .member {\n    width: calc(50% - 18px);\n  }\n}\n\n@media (max-width: 768px) {\n  .footer-container {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .footer-links {\n    margin-bottom: 0.5rem;\n  }\n}\n\n@media (max-width: 3840px) {\n  #game {\n    transform: scale(1.0); /* Scale down to 90% on smaller screens */\n    transform-origin: center;   \n  }\n\n  #nav-container {\n    transform: scale(0.8); /* Scale down to 80% on even smaller screens */\n    transform-origin: center;   \n  }\n}\n\n@media (max-width: 1920px) {\n  #game {\n    transform: scale(0.98); /* Scale down to 90% on smaller screens */\n    transform-origin: center;   \n    padding-left: 10px;\n  }\n\n  #whenplane {\n    transform: scale(0.98); \n  }\n}\n\n@media (max-width: 1200px) {\n  #game {\n    transform: scale(0.98);  \n    transform-origin: center;   \n    padding-left: 10px;\n    margin-left: 18px;\n  }\n\n  #whenplane {\n    transform: scale(0.98);\n    margin-top: 0px;  \n  }\n}\n\n@media (max-width: 1150px) {\n  #game {\n    transform: scale(0.96);  \n    transform-origin: center;   \n    padding-left: 10px;\n    margin-left: 18px;\n  }\n\n  #whenplane {\n    transform: scale(0.96);\n    margin-top: -2px;  \n  }\n}\n\n@media (max-width: 1100px) {\n  #game {\n    transform: scale(0.99);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n\n  #whenplane {\n    transform: scale(0.99);\n    margin-top: 0px;  \n  }\n}\n\n@media (max-width: 1070px) {\n  #game {\n    transform: scale(0.98);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1060px) {\n  #game {\n    transform: scale(0.97);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1050px) {\n  #game {\n    transform: scale(0.96);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1040px) {\n  #game {\n    transform: scale(0.95);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1030px) {\n  #game {\n    transform: scale(0.94);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1020px) {\n  #game {\n    transform: scale(0.93);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1010px) {\n  #game {\n    transform: scale(0.92);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n\n  #whenplane {\n    transform: scale(0.92);  \n  }\n}\n\n@media (max-width: 1000px) {\n  #game {\n    transform: scale(0.91);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n    margin-top: -80px;\n  }\n}\n\n@media (max-width: 950px) {\n  #game {\n    transform: scale(0.86);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n    margin-top: -100px;\n  }\n}\n\n@media (max-width: 900px) {\n  #game {\n    transform: scale(0.81);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n    margin-top: -120px;\n  }\n\n  #whenplane {\n    transform: scale(0.81);\n    margin-top: -125px;  \n  }\n}\n\n@media (max-width: 850px) {\n  #game {\n    transform: scale(0.76);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n    margin-top: -140px;\n  }\n\n  #whenplane {\n    transform: scale(0.76);\n    margin-top: -150px;  \n  }\n}\n\n@media (max-width: 800px) {\n  #game {\n    transform: scale(0.71);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 3px;\n    margin-top: -160px;\n  }\n\n  #whenplane {\n    transform: scale(0.71);\n    margin-top: -175px;  \n  }\n}\n\n@media (max-width: 750px) {\n  #game {\n    transform: scale(0.66);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 2px;\n    margin-top: -180px;\n  }\n\n  #whenplane {\n    transform: scale(0.66);\n    margin-top: -200px;  \n  }\n}\n\n@media (max-width: 600px) {\n  #game {\n    transform: scale(0.56);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 1px;\n    margin-top: -200px;\n  }\n\n  #whenplane {\n    transform: scale(0.56);\n    margin-top: -275px;  \n  }\n}\n\n@media (max-width: 550px) {\n  #game {\n    transform: scale(0.52);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 0px;\n    margin-top: -220px;\n  }\n}\n\n@media (max-width: 500px) {\n  #game {\n    transform: scale(0.48);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 0px;\n    margin-top: -240px;\n  }\n\n  #whenplane {\n    transform: scale(0.48);  \n    padding-top: -50px;\n  }\n}\n\n@media (max-width: 480px) {\n  #game {\n    transform: scale(0.46); /* Scale down to 50% on the smallest screens */\n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 0px;\n    margin-top: -248px;\n  }\n}\n\n@media (max-width: 450px) {\n  #game {\n    transform: scale(0.42);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 0px;\n    margin-top: -260px;\n  }\n}\n\n@media (max-width: 768px) {\n  .nav-links {\n    display: none;\n  }\n\n  .hamburger-menu {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
